module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "feedModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.FEE000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "feed-modal-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFeedPostContent),
      expression: "newFeedPostContent"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputNewFeedPost",
      "rows": "3",
      "maxlength": "1000",
      "placeholder": _vm.lang.FEE001
    },
    domProps: {
      "value": (_vm.newFeedPostContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newFeedPostContent = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "disabled": !_vm.newFeedPostContent
    },
    on: {
      "click": function($event) {
        return _vm.addFeedPost()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.FEE002) + "\n              ")])])]), _vm._v(" "), (_vm.currentFeedPosts.length < 1) ? _c('div', [_vm._v(_vm._s(_vm.lang.FEE003))]) : _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.FEE004) + "\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-left",
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.FEE005) + "\n                ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.currentFeedPosts), function(post) {
    return _c('tr', {
      key: post.FeedPostGuid
    }, [_c('td', {
      staticClass: "text-left"
    }, [_c('b', [_vm._v(_vm._s(post.FeedPostCreatedBy.Lastname) + ",\n                    " + _vm._s(post.FeedPostCreatedBy.Firstname))]), _vm._v("\n                  -\n                  "), _c('span', {
      class: {
        'text-red text-bold': post.FeedPostCreatedBy.Username ===
          _vm.globals.currentUserName,
      }
    }, [_vm._v(_vm._s(post.FeedPostCreatedBy.Username))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "post-creation-timestamp"
    }, [_vm._v(_vm._s(_vm.globals.getLocalizedDateTimeFromUtcIsoTimestamp(
      post.FeedPostCreatedAt
    )))])]), _vm._v(" "), _c('td', {
      staticClass: "text-left",
      domProps: {
        "innerHTML": _vm._s(_vm.addContentHighlighting(post.Content))
      }
    })])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.FEE006) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-721540f6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tools/Dialogs/FeedModal.vue
// module id = 1794
// module chunks = 2